import { FormElementMeta } from '@sierralabs/forms-core';
import { DynamicFormMultiSelectConfig } from '../dynamic-forms/plugins/form-elements/FormMultiSelectPlugin';
import { log } from '../tools/LogHelper';

function isOtherSelected(value: any): boolean {
  if (Array.isArray(value)) {
    return value.some(v => v === 'Other');
  }
  return value === 'Other';
}

export function validateFormOtherFieldValue<
  FormValuesType,
  FormElementConfigType
>(
  element: FormElementMeta<FormValuesType, FormElementConfigType>,
  formValues: Partial<FormValuesType>
): boolean {
  const config = element.config as DynamicFormMultiSelectConfig;
  const value = (formValues as any)[element.dataSource || element.key];

  if (isOtherSelected(value) && config.enableOtherOption) {
    const otherOptionConfig = config.otherOptionConfig || {};
    const otherKey = otherOptionConfig.dataSource as string | undefined;
    if (!otherKey?.trim()) {
      log(
        'validateFormOtherFieldValue: otherOptionConfig.dataSource is not set; skipping Other text validation (element key:',
        String(element.key),
        ')'
      );
      return true;
    }
    const otherValue = (formValues as any)[otherKey] as
      | string
      | null
      | undefined;
    if (!otherValue?.trim()) return false;
  }
  return true;
}
